// import {
// 	AccordionItem,
// 	AccordionItemTitle,
// 	AccordionItemBody,
// 	Accordion,
// } from 'react-accessible-accordion'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationCircle,
  faHourglassEnd,
  faRetweet,
} from '@fortawesome/free-solid-svg-icons'
import { useEffect, useRef, useState } from 'react'

import './style.css'

import * as Reactstrap from 'reactstrap'
import { Link } from 'react-router-dom'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getExemptCourses } from 'store/EmployeeReport/actions'
import { useDispatch } from 'react-redux'
import { fetchUserExternalReports } from 'store/ExternalReports/actions'

/*eslint-disable*/

const getGroupStatus = (status, reassigned, expired, language) => {
  if (status === 3)
    return (
      <>
        <FontAwesomeIcon
          style={{ marginRight: '5px' }}
          icon={faExclamationCircle}
        />
        {language.general ? language.general.validation : null}
      </>
    )
  else if (reassigned)
    return (
      <>
        <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faRetweet} />
        {language.groups ? language.groups.reassigned : null}
      </>
    )
  else if (expired)
    return (
      <>
        <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faHourglassEnd} />
        {language.groups ? language.groups.expired : null}
      </>
    )
}

const CustomAccordionItem = (props) => {
  const contentEl = useRef()
  const { handleToggle, active, title, id, group } = props
  // const language = useSelector((state) => state.language?.language?.data)
  const language = props.language || {}
  return (
    <div className='rc-accordion-card'>
      <div className='rc-accordion-header'>
        <div
          className={`rc-accordion-toggle p-2 ${active === id ? 'active' : ''}`}
          onClick={() => handleToggle(id)}
        >
          <div>
            <h5 className='rc-accordion-title'>{title}</h5>
            <small className='rc-accordion-date'>
              {' '}
              {moment(group.end_date).isValid() ? (
                <>
                  {language.general && language.general.due}{' '}
                  {moment(group.end_date).format('M/D/YYYY')}
                </>
              ) : (
                language.general && language.general.no_due_date
              )}
            </small>
          </div>
          <i className='fa fa-chevron-right rc-accordion-icon'></i>
        </div>
      </div>
      <div
        ref={contentEl}
        className={`rc-collapse ${active === id ? 'show' : ''}`}
        style={
          active === id
            ? { height: contentEl.current.scrollHeight }
            : { height: '0px' }
        }
      >
        <div className='d-flex flex-column scrollbar overflow-auto'>
          {props.children}
        </div>
      </div>
    </div>
  )
}

const CoreTrainingProgress = (originalProps) => {
  let courseProgress = []
  let courseUserProgress = []
  let courseProgressFilter = []

  const dispatch = useDispatch()
  const employeeReport = useSelector((state) => state.employeeReport)
  const externalReports = useSelector((state) => state.externalReports)
  const {
    user: { id: userId },
  } = useSelector((state) => state.auth)

  const props = { ...originalProps, ...externalReports }

  // useEffect(() => {
  //   dispatch(getExemptCourses(userId))
  //   dispatch(fetchUserExternalReports(userId))
  // }, [])

  const [active, setActive] = useState(null)

  const handleToggle = (index) => {
    if (active === index) {
      setActive(null)
    } else {
      setActive(index)
    }
  }

  const filteredGroups = useMemo(() => {
    const filteredGroups = props.groups.groups.filter((group) => {
      let groupStatus = null
      if (props.groups.groupStatus) {
        groupStatus = props.groups.groupStatus.find(
          (item) => item.id === group.id
        )
      }
      return (
        group.tags !== null && groupStatus && groupStatus.past_due === false
      )
    })
    return filteredGroups
  }, [props.groups.groups, props.groups.groupStatus])

  filteredGroups.forEach((group) => {
    if (group.tags.includes(props.tag)) {
      if (props.groups.groupsCourses[group.id]) {
        props.groups.groupsCourses[group.id].forEach((item) => {
          if (
            !props?.employee?.exemptCourses ||
            !Array.isArray(employeeReport.exemptCourses) ||
            !employeeReport.exemptCourses.find(
              (exemptItem) => exemptItem.course_id == item.course_id
            )
          ) {
            props.courses.userProgress.forEach((progressItem) => {
              if (
                progressItem.course_id === item.course_id &&
                progressItem.status === 4
              ) {
                courseUserProgress = [...courseUserProgress, item.course_id]
              }
            })

            props.courses.progress.forEach((progress) => {
              if (progress.id === item.course_id) {
                courseProgress = [...courseProgress, item.course_id]
              }
            })
          }
        })
      }
    }
  })

  courseProgressFilter = courseUserProgress.filter(
    (value, index, self) => self.indexOf(value) === index
  )

  const noDuplicatedCourseProgress = courseProgress.filter(
    (item, index) => index === courseProgress.findIndex((elem) => elem === item)
  )

  const coursesLen =
    props.tag == 1
      ? noDuplicatedCourseProgress.length + props.userExternalReports.length
      : noDuplicatedCourseProgress.length

  const noDuplicateCourseUserProgress = courseUserProgress.filter(
    (item, index) =>
      index === courseUserProgress.findIndex((elem) => elem === item)
  )

  const completedLen =
    props.tag == 1
      ? noDuplicateCourseUserProgress.length + props.userExternalReports.length
      : noDuplicateCourseUserProgress.length

  let percentage = coursesLen >= 0 ? (completedLen / coursesLen) * 100 : null

  let stroke =
    coursesLen - completedLen === 0
      ? 141.392
      : 141.392 * ((coursesLen - completedLen) / coursesLen)

  if (parseInt(percentage) > 100) {
    stroke = 0
  }

  if (coursesLen === 0) {
    percentage = 0
  }

  return (
    <div className=''>
      <div
        style={{
          maxHeight: '212px',
          marginBottom: '0px',
        }}
      >
        <div className='progress-bar-wrapper d-flex flex-column justify-content-center align-items-center border-bottom'>
          <svg viewBox='0 0 100 50'>
            <path
              d='M 50,50 m -45,0 a 45,45 0 1 1 90,0'
              stroke='#dedede'
              strokeWidth='10'
              fillOpacity='0'
              strokeLinecap='round'
            ></path>

            <path
              d='M 50,50 m -45,0 a 45,45 0 1 1 90,0'
              stroke='#5bc0de'
              strokeWidth='10'
              fillOpacity='0'
              strokeLinecap='round'
              style={{
                strokeDasharray: '141.392, 141.392',
                strokeDashoffset: stroke,
              }}
            ></path>
          </svg>

          <div>
            {percentage !== null ? (
              <div className='progress-bar-text '>
                {parseInt(percentage) > 100 ? 100 : parseInt(percentage)}%
                <p>{props.name}</p>
              </div>
            ) : (
              <div className='progress-bar-text font-weight-normal text-sm'>
                <Reactstrap.Spinner type='grow' color='success' />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='' style={{ height: '320px' }}>
        <div className='scrollbar overflow-auto' style={{ maxHeight: '300px' }}>
          {(() => {
            let noDueDataGroupCourses = props.groups.learningPlanGroups.filter(
              (item) =>
                item.dates_disabled === 1 ||
                item.end_date === '0000-00-00 00:00:00'
            )

            let dueGroupCourses = props.groups.learningPlanGroups
              .filter(
                (item) =>
                  item.dates_disabled === 0 &&
                  item.end_date !== '0000-00-00 00:00:00'
              )
              .sort((a, b) => (a.end_date > b.end_date ? 1 : -1))

            const groupCourses = [...dueGroupCourses, ...noDueDataGroupCourses]

            return groupCourses.map((group, index) => {
              const dueDate = moment().isBefore(moment(group.end_date))
                ? ''
                : moment(group.end_date).isValid()
                ? 'due-date-expired'
                : ''
              let courses = props.groups.groupsCourses[group.id]
              if (courses) {
                courses = courses.filter((item) => {
                  if (
                    !props?.employee?.exemptCourses ||
                    !Array.isArray(employeeReport.exemptCourses)
                  ) {
                    return true
                  }

                  return !employeeReport.exemptCourses.find(
                    (exemptCourse) => exemptCourse.course_id === item.course_id
                  )
                })
              }

              let groupStatus = null
              props.groups.groupStatus
                ? (groupStatus = props.groups.groupStatus.find(
                    (item) => item.id === group.id
                  ))
                : null

              if (
                group.tags.includes(props.tag) &&
                (groupStatus || !groupStatus)
              ) {
                if (!courses || !courses.length) {
                  return
                }

                return (
                  <CustomAccordionItem
                    key={index}
                    title={group.name}
                    handleToggle={handleToggle}
                    active={active}
                    id={group.id}
                    group={group}
                    language={props.language}
                  >
                    {(() => {
                      if (courses) {
                        return courses.map((singleCourse, courseIndex) => {
                          const currentCourse = props.courses?.progress.find(
                            (courseId) => courseId.id === singleCourse.course_id
                          )

                          if (currentCourse) {
                            const currentCourseStatus =
                              props.courses.userProgress.find(
                                (item) => item.course_id === currentCourse.id
                              )
                            const exemptCourse =
                              Array.isArray(props?.employee?.exemptCourses) &&
                              employeeReport.exemptCourses.find(
                                (exemptCourse) =>
                                  exemptCourse.course_id === currentCourse.id
                              )
                            if (exemptCourse) {
                              return null
                            }

                            if (
                              !currentCourse &&
                              currentCourse.redirect_url &&
                              !(
                                currentCourseStatus &&
                                currentCourseStatus.status > 0
                              )
                            ) {
                              return (
                                <div
                                  key={courseIndex}
                                  className={`border-bottom ${
                                    currentCourseStatus &&
                                    currentCourseStatus.status === 4
                                      ? 'course-completed'
                                      : ''
                                  }`}
                                >
                                  <a
                                    title={props.name}
                                    target='_blank'
                                    href={`${currentCourse.redirect_url}?firstname=${props.first_name}&lastname=${props.last_name}&language=en_US&courseid=${currentCourse.id}&kid=${props.id}`}
                                  >
                                    <img
                                      className='course-small-thumb'
                                      style={{ objectFit: 'cover' }}
                                      src={currentCourse.image}
                                      width='35px'
                                      height='35px'
                                    />
                                    <span>{currentCourse.name}</span>
                                  </a>
                                </div>
                              )
                            } else {
                              return (
                                <div
                                  key={courseIndex}
                                  className={`border-bottom ${
                                    currentCourseStatus &&
                                    currentCourseStatus.status === 4
                                      ? 'course-completed'
                                      : ''
                                  }`}
                                >
                                  <Link
                                    title={currentCourse.name}
                                    to={`/course/${currentCourse.id}`}
                                    className='text-darker'
                                  >
                                    <img
                                      className='course-small-thumb'
                                      style={{ objectFit: 'cover' }}
                                      src={currentCourse.image}
                                      width='36px'
                                      height='36px'
                                    />
                                    <span className='ml-2'>
                                      {currentCourse.name}
                                    </span>
                                  </Link>
                                </div>
                              )
                            }
                          }
                          return
                        })
                      }
                      return
                    })()}
                  </CustomAccordionItem>
                )
              }
              return
            })
          })()}
        </div>
      </div>
    </div>
  )
}

export default CoreTrainingProgress
